//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import '@media-library/components/MediaLibraryContent.tsx';

(function () {
  const curalate = angular.module('curalate');

  curalate.component('contentLibraryContentGridWithFilters', {
    bindings: {
      filterSetNames: '<',
      collectionId: '<',
      additionalFilters: '<',
      viewMode: '<',
      scrollContainer: '<',
      detailLinkClicked: '&',
    },
    template: require('@legacy-components/content/content-library-content-grid-with-filters/content-library-content-grid-with-filters.html'),
    controller: [
      'rx',
      'SearchFilterService',
      function (rx, SearchFilterService) {
        const self = this;

        let currentFilters = {};

        this.filters = {};
        this.ready = false;

        this.$onChanges = function (changesObj) {
          if (changesObj.additionalFilters) {
            currentFilters = angular.copy(
              _(currentFilters).extend(
                changesObj.additionalFilters.currentValue,
              ),
            );
            self.filters = angular.copy(currentFilters);
          }
        };

        this.$onInit = function () {
          let mergedFilterStream = new rx.BehaviorSubject({});

          if (self.filterSetNames) {
            _(self.filterSetNames).each((setName) => {
              const setStream =
                SearchFilterService.getFlattenedObservableForFilterSet(setName);
              mergedFilterStream = mergedFilterStream.merge(setStream);
            });
            this.filterSetSubscription = mergedFilterStream
              .map((setUpdate) => setUpdate.setObject)
              .do((setObject) => {
                currentFilters = angular.copy(
                  _(currentFilters).extend(setObject),
                );
              })
              .debounceTime(300)
              .subscribe(() => {
                self.ready = true;
                self.filters = angular.copy(currentFilters);
              });
          }
        };

        this.$onDestroy = function () {
          if (this.filterSetSubscription) {
            this.filterSetSubscription.unsubscribe();
          }
        };
      },
    ],
  });
})();
